import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './ToolsListView.module.scss';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';

export const ToolsListView = ({ listItems = [], handleSelection }) => {
	const { user, access } = useAuthorizationContext();
	return (
		<>
			<div className={styles.toolListView}>
				<div className={styles.toolListTitleContainer}>
					<span className={clsx(styles.toolListTitle)}>Tools</span>
				</div>
				{listItems.map(
					(item, index) =>
						user?.user_role?.some((role) =>
							access[role]?.some(
								(module) => module.key === item?.privilege.toLowerCase()
							)
						) && (
							<button
								type="button"
								onClick={() =>
									item.action ? item.action() : handleSelection(item)
								}
								className={clsx(styles.toolListItem)}
								key={index}
								style={{
									display: 'flex',
								}}
							>
								<span>{item.label}</span>
							</button>
						)
				)}
			</div>
		</>
	);
};

ToolsListView.propTypes = {
	listItems: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			action: PropTypes.func,
		})
	),
	handleSelection: PropTypes.func.isRequired,
};
